<template>
 <div :class="windowClass">
        <v-row no-gutters>
            <v-col md="8"
            offset-md="2"
            class="pa-1 mt-10">
                 <v-card>
                     <v-card-title>
                          <span style="width: 200px; margin-right: 4px;">
                          <v-select
                           filled
                            outlined
                            label="Select Type"
                            @change="clear(),getCustomers()"
                            dense
                          v-model="paymentType"
                          :items="CUSTOMERTYPES"
                          />
                          </span>
                            <v-autocomplete
                            dense
                            filled
                            outlined
                            success
                            v-model="customer"
                            :items="customers"
                            item-text="firstname"
                            item-value="id"
                            @change="getSale()"
                            label="Select Customer"
                              return-object
                            ></v-autocomplete>
                     </v-card-title>
                     <v-card-text>
                        <v-row no-gutter>
                          <v-spacer/>
                          <v-card class="elevation-0" width="220">
                                  <v-menu
                                  ref="menu"
                                  v-model="datemenu"
                                  :close-on-content-click="false"
                                  transition="scale-transition"
                                  offset-y
                                  :min-width="paymentType =='credit'?'600px':'290px'"
                              >
                                  <template v-slot:activator="{ on }">
                                  <v-text-field
                                      :value="selected_date"
                                      label="select date range"
                                      prepend-icon="mdi-calendar"
                                      readonly
                                      dense
                                      single-line
                                      class="mr-2 sm-width"
                                      hide-details
                                      v-on="on"
                                  ></v-text-field>
                                  </template>
                                  <v-date-picker class="ma-1" v-model="selected_date" no-title scrollable @input="CurrentItems=[], paymentType =='Cash'?getCustomers():getSale(), paymentType =='Cash'?datemenu = false:CurrentItems=[]" />
                                   <!-- <v-date-picker v-if="paymentType =='Credit'" class="ma-1" v-model="selected_date2" no-title scrollable @input="datemenu = false, CurrentItems=[], getSale()" /> -->
                              </v-menu>
                            </v-card>

                        </v-row>
                             <div class="text-left"><v-icon @click="cashierprint=true">mdi-printer</v-icon></div>
                            <v-data-table
                                class="va-table"
                                :headers="headers"
                                :items-per-page="10"
                                :items="CurrentItems"
                                disable-sort
                                >
                                <template v-slot:body="{ items }">
                                    <tbody>
                                    <tr v-for="(item,index) in items" :key="index">
                                            <td>
                                              <v-icon v-if="IS_ADMIN()" @click="sales=item, state='update', form=true" left color="warning" small>mdi-pencil</v-icon>
                                            {{ item.name }}
                                            </td>
                                           <td>
                                                {{ $money(item.price) }}
                                            </td>
                                            <td class="text-right">
                                                {{ $money(item.kilos) }}
                                            </td> <td class="text-right">
                                                {{ $money(parseFloat(item.kilos) * parseFloat(item.price)) }}
                                            </td>
                                            <td class="text-right">
                                                {{ $money(item.service_charge) }}
                                            </td>
                                            <td class="text-right">
                                                {{ $money(item.trucking_fee) }}
                                            </td>
                                            <td class="text-right">
                                                {{ $money(($IsNum(item.price) * $IsNum(item.kilos)) +  $IsNum(item.trucking_fee) + $IsNum(item.service_charge)) }}
                                            </td>
                                    </tr>
                                     <tr class="title">
                                            <td>
                                                <!-- Sales Date: {{$moment(selected_date).format("YY-MMM-dddd")}} -->
                                            </td>
                                           
                                            <td class="text-right" colspan="2">
                                              AS of:{{$moment(selected_date).format("YY-MMM-dddd")}}
                                            </td>
                                             <td class="text-right">
                                             
                                            </td>
                                            <td class="text-right">
                                                {{ $money(SERVICE_CHARGE) }}
                                            </td>
                                            <td class="text-right">
                                                {{ $money(TRUCKING_FEE) }}
                                            </td>
                                            <td class="text-right">
                                                {{ $money(TOTAL_AMOUNT) }}
                                            </td>
                                    </tr>
                                   
                                    </tbody>
                                </template>
                          </v-data-table>
                     </v-card-text>
                     <v-card-actions v-if="paymentType == 'Credit'">
                        <p  class="pa-2">     
                        <v-icon left color="secondary">mdi-cart</v-icon> <span class="va-underline">SALES </span><br /> 
                        <span>{{$money(account.collectible)}}</span>
                        </p>
                        <v-spacer />
                        <p  class="pa-2">
                        <v-icon left color="secondary">mdi-bank-transfer-in</v-icon> <span class="va-underline">PAYMENTS</span> <br /> 
                        <span>{{$money(account.payout)}}</span>
                        </p>
                        <v-spacer />
                        <p  class="pa-2">
                        <v-icon left color="secondary">mdi-account-cash</v-icon> <span class="va-underline">COLLECTIBLES</span><br /> 
                        <span>{{$money(TOTAL_CURRENT_COLLECTIBLE)}}</span>
                        </p>
                     </v-card-actions>
                 </v-card>
                
                <v-footer class="pa-0 mt-10" v-if="PAYBTN && !IS_PAID">
                  <v-btn large color="warning" @click="clear()">Clear</v-btn>
                  <v-spacer/>
                  <v-btn @click="cashierprint=true" text class="mr-2"><v-icon>mdi-printer</v-icon></v-btn>
                  
                  <template v-if="CANDOPAY && TOTAL_CURRENT_COLLECTIBLE>0 && paymentType == 'Credit'">
                      <v-btn large color="secondary" @click="setPayment()">PAY</v-btn>
                  </template>
                  <template v-if="CANDOPAY && TOTAL_AMOUNT>0 && paymentType == 'Cash'">
                      <v-btn large color="secondary" @click="setPayment()">PAY</v-btn>
                  </template>
                </v-footer>
                <p class="caption pa-4" style="color: green;" v-if="IS_PAID">
                   <v-icon small left color="success">mdi-check-circle</v-icon> PAYMENT COMPLETED
                </p>
            </v-col>
        </v-row>
        <va-sales-form :show="form" :sales="sales" :state="state" :customers="all_customers" :fishcars="FISHCARS"  @DialogEvent="formEvent" />
        <va-pay-form :show="payform" :payment="payment" :type="paymentType" @DialogEvent="payEvent" :sales_date="selected_date" v-if="paymentType =='Credit'" />
        <va-pay-cash-form :show="payform" :payment="payment" :type="paymentType" @DialogEvent="payEvent" :sales_date="selected_date" v-if="paymentType =='Cash'" />
        <print-cashier :show="cashierprint" :items="CurrentItems" :customer="customer" @DialogEvent="prEvent" />
  </div>
</template>
<script>
import { API_MIXINS } from '@/mixins/api_mixins.js'
import {
  mapMutations
} from 'vuex'
  export default {
    mixins: [API_MIXINS],
    data: () => ({
        form: false,
        paymentType:"Cash",
        cashierprint: false,
        payform: false,
        loading: false,
        customer:{},
        payments:[],
        payment:{},
        postedpayments:[],
        account:{},
        customers:[],
        CurrentItems:[],
        datemenu: false,
        sales:{},
        settings:[],
        state: 'update',
        selected_date:'',
        selected_date2: '',
        Fishcars:[],
        all_customers:[],
        headers:[
            {text: 'Fish', value: 'name', sortable: false},
            {text: 'Price/Kg', value: 'price', sortable: false},
            {text: 'Weight(Kg)', value: 'kilos', sortable: false, align: 'right'},
             {text: 'Amount', sortable: false, align: 'right'},
             {text: 'SC', value: 'service_charge', sortable: false, align: 'right'},
            {text: 'Trucking', value: 'trucking_fee', sortable: false, align: 'right'},
            {text: 'Total',sortable: false, align: 'right'}
        ],
    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {


       if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.setLoggedIn(true) 
          this.selected_date = this.$moment().format('YYYY-MM-DD')
          this.selected_date2 = ""//this.$moment().format('YYYY-MM-DD')
            this.loadSetting()
            this.getCustomers()
            this.getAllCustomers()
            this.GET_TRANSACTIONS({param1: this.selected_date})
            this.getFishcars() 
      
        }
    },
    computed:{
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
      CANDOPAY() {
            if(!this.$session.get('permission')) {
              return true
            } 
            if(this.CHECKPERMISSION('Cash Only') || this.CHECKPERMISSION('Credit Only')) {
              return true
            }   
             return false
      },
      CUSTOMERTYPES(){
          if(!this.$session.get('permission')) {
                return ["Cash", "Credit"]
            }
        if(this.CHECKPERMISSION('Cash Only')) {
            return ["Cash"]
        } else if(this.CHECKPERMISSION('Credit Only')) {
            return ["Credit"]
        } else {
           return ["Cash", "Credit"]
        }
          
      },
     AMOUNT() {
          var total = 0
            for(var i =0;i<this.CurrentItems.length;i++) {
              total += this.$IsNum(this.CurrentItems[i].price) * this.$IsNum(this.CurrentItems[i].kilos)
          }
          return total
      },
      KILOS() {
          var total = 0
            for(var i =0;i<this.CurrentItems.length;i++) {
              total += this.$IsNum(this.CurrentItems[i].kilos)
          }
          return total
      },
      SERVICE_CHARGE() {
          var total = 0
            for(var i =0;i<this.CurrentItems.length;i++) {
              total += this.$IsNum(this.CurrentItems[i].service_charge)
          }
          return total
      },
      TRUCKING_FEE() {
          var total = 0
            for(var i =0;i<this.CurrentItems.length;i++) {
              total += this.$IsNum(this.CurrentItems[i].trucking_fee)
          }
          return total
      },
      TOTAL_AMOUNT(){
          return this.AMOUNT + this.SERVICE_CHARGE + this.TRUCKING_FEE
      },
      FISHCARS(){
       return this.Fishcars
      },
      PAYBTN(){
        if(this.paymentType == 'Credit') {
          return true
        } else {
          if(this.CurrentItems.length > 0) {
             return true
           } 
        }
        return false
      },
      ITEM_IDS(){
         var ids = []
            for(var i =0;i<this.CurrentItems.length;i++) {
              ids.push(this.CurrentItems[i].id)
          }
          return ids
      },
      IS_PAID(){
         for(var i =0;i<this.payments.length;i++) {
              if(this.payments[i].type == 4) {
                  return true
              }
          }
          return false
     },
      SALESIDS() {
          var ids = []
            for(var i =0;i<this.CurrentItems.length;i++) {
              ids.push(this.CurrentItems[i].id)
          }
          return ids
      },
      TOTAL_CURRENT_COLLECTIBLE() {
        return this.$IsNum(this.account.collectible) - this.$IsNum(this.account.payout)
      },
      POSTED_PAYMENT(){
      let posted =  this.postedpayments.reduce((res, item) =>res += this.$IsNum(item.amount), 0)
      return posted
     },
     BALANCETODATE(){
      return this.TOTAL_AMOUNT - this.POSTED_PAYMENT
     }
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
      getPayment(){
      var param= {}
        param.start_date = this.selected_date
        param.account = this.customer.id
        console.log(param)
        this.$http.post("transaction/get_payment", param).then(response => { 
            this.postedpayments = response.data.data
        })
    },
      setPayment() {
        this.payment.amount = this.TOTAL_AMOUNT
        this.payment.service_charge = this.SERVICE_CHARGE
         this.payment.trucking_fee = this.TRUCKING_FEE
         this.payment.customer = this.customer.id 
         this.payment.email = this.customer.email 
        this.payment.items = this.ITEM_IDS
        this.payform = true
      },
      prEvent(){
        this.cashierprint =false
      },
      payEvent(data){
        this.payment={}
          this.payform = false
          if(data == 'completed') {
            if(this.paymentType == 'Cash') {
              this.UpdateIds()
              this.clear()
            } else {
              this.getAccountSummary()
              this.getSale()
            }
            
          }
      },
      formEvent(data){
        this.form = false
        if(data.action == 'update') {
            this.sales = data.sales
            this.Save()
        }
      },
      getFishcars: function() {
        this.$http.post("supplier/list", {}).then(response => {
              response.data.data != null?this.Fishcars = response.data.data:this.Fishcars=[]
          }).catch(e => {
           console.log(e.data)
         })
     },
       Save(){
            this.$http.post("sale/update", this.sales).then(response => {
            if(response.data.status == true) {
                this.VA_ALERT('success', response.data.message)
            } else {
                this.VA_ALERT('error', response.data.message)
            }
            // this.getTransactions()
            }).catch(e => {
            console.log(e)
            })
        },
        clear() {
          this.customer = {}
          this.CurrentItems = []
          this.account = {}
          this.payments = []
        },
        UpdateIds(){
         this.$http.post("sale/update_status_multiple_id", {ids:this.SALESIDS, to_do:"status", str_val:"paid"}).then(response => {
            if(response.data.status) {
              this.getCustomers()
            }
            }).catch(e => {
            console.log(e.data)
          }) 
      },
      getSale(){
        this.getPayment()
        this.CurrentItems = []
          if(this.paymentType == 'Credit') {
               this.getCreditSales()
            } else {
              this.getCashSales()
            }
      },
      
       getModified() {
       this.modifiedData = []
        this.$http.post("modify/query", {customer_id: this.customer.id, sales_date: this.selected_date}).then(response => {
          response.data.data != null?this.CurrentItems= response.data.data.data:this.getCashSales()
         // console.log(response.data.data )
            }).catch(e => {
            console.log(e.data)
          }) 
     },
      getCashSales() {
        this.$http.post("customer/get_order", {id: this.customer.id, status: this.selected_date}).then(response => {
          response.data.data != null?this.CurrentItems = response.data.data:this.CurrentItems = []
            }).catch(e => {
            console.log(e.data)
          }) 
      },
      getCreditSales() {
        this.$http.post("customer/get_credit_sales", {customer: this.customer.id, date: this.selected_date, date2: this.selected_date}).then(response => {
          response.data.data != null?this.CurrentItems = response.data.data:this.CurrentItems = []
          this.getAccountSummary()
            }).catch(e => {
            console.log(e.data)
          }) 
      },
   getAccountSummary(){
        this.$http.post("transaction/query_total", {account: this.customer.id, account_type: 3}).then(response => {
              response.data.data != null?this.account = response.data.data:this.account={}
              console.log(this.account)
         }).catch(e => {
           console.log(e.data)
         })
     },
     
      loadSetting() {
          this.$http.post("setting/list", JSON.stringify({})).then(response => {
            response.data.data != null?this.settings = response.data.data:this.settings = []
          }).catch(e => {
           console.log(e.data)
         })
      },
      getSettingVal(name) {
          for(var i =0;i<this.settings.length;i++) {
              if(this.settings[i].name == name) {
                  return this.settings[i].value
              }
          }
          return false
      },
      getCustomers: function() { 
            var method = "by_date"
            if(this.paymentType == 'Credit') {
               method = "all_credits"
            }
            console.log({method: method, param1: this.selected_date})
             this.$http.post("customer/list", JSON.stringify({method: method, param1: this.selected_date})).then(response => {
            response.data.data != null?this.customers = response.data.data:this.customers = []
          }).catch(e => {
           console.log(e.data)
         })
     },
      getAllCustomers: function() { 
          this.$http.post("customer/list", JSON.stringify({})).then(response => {
            response.data.data != null?this.all_customers = response.data.data:this.all_customers = []
          }).catch(e => {
           console.log(e.data)
         })
     }
    }
  }
</script>